import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addGateSuccess,
  addGateFailure,
  //
  deleteGateSuccess,
  deleteGateFailure,
  //
  editGateSuccess,
  editGateFailure,
  //
  fetchGatesSuccess,
  fetchGatesFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  getBookInfoSuccess,
  getBookInfoFailure,
  //
  inviteVisitorSuccess,
  inviteVisitorFailure,
} from "./actions";
import {
  ADD_GATE,
  DELETE_GATE,
  EDIT_GATE,
  FETCH_GATES,
  GET_VIEW_DATA,
  GET_BOOK_INFO,
  INVITE_VISITOR,
} from "./constants";

export function* fetchGatesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/visitor-book?${query}`);
    yield put(fetchGatesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchGatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching gate list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/visitor-book/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching visitor data!"));
  }
}

export function* addGateSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/visitor-book/add`, payload);
    if (data) {
      yield put(successAlert("Entrance created successfully!"));
      yield put(addGateSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addGateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editGateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/visitor-book/update/${payload.id}`,
      payload?.data
    );
    if (data) {
      yield put(successAlert("Entrance updated successfully!"));
      yield put(editGateSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editGateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteGateSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/visitor-book/${payload}`);
    if (data) {
      yield put(successAlert("Entrance deleted successfully!"));
      yield put(deleteGateSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteGateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getBookInfoSaga({ payload = { cancelToken: null } }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/entry-details/${payload}`
    );
    yield put(getBookInfoSuccess(data));
  } catch (e) {
    yield put(getBookInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching visitor data!"));
  }
}

export function* inviteVisitorSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/send-visitor-invite-mail`,
      payload
    );
    if (data) {
      yield put(successAlert("Visitor book access link sent!"));
      yield put(inviteVisitorSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(inviteVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchGatesFlow() {
  yield takeEvery(FETCH_GATES, fetchGatesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addGateFlow() {
  yield takeEvery(ADD_GATE, addGateSaga);
}
export function* editGateFlow() {
  yield takeEvery(EDIT_GATE, editGateSaga);
}
export function* deleteGateFlow() {
  yield takeEvery(DELETE_GATE, deleteGateSaga);
}
export function* getBookInfoFlow() {
  yield takeEvery(GET_BOOK_INFO, getBookInfoSaga);
}
export function* inviteVisitorFlow() {
  yield takeEvery(INVITE_VISITOR, inviteVisitorSaga);
}

export default function* VisitorGateSaga() {
  yield all([
    fetchGatesFlow(),
    addGateFlow(),
    editGateFlow(),
    deleteGateFlow(),
    getViewDataFlow(),
    getBookInfoFlow(),
    inviteVisitorFlow(),
  ]);
}
